<div class="dish-account-import">
    <nz-card class="import-card">
        <div class="header">
            <h1>Dish Account Import</h1>
            <p>Enter the customer details you received from Dish and trigger a manual sync.</p>
        </div>

        <form nz-form [formGroup]="dishAccountForm" (ngSubmit)="submitManualSync()" class="import-form">
            <div class="form-grid">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>Account Number</nz-form-label>
                    <nz-form-control nzErrorTip="Account number is required">
                        <input nz-input formControlName="accountNumber" placeholder="Account number" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>Last Name</nz-form-label>
                    <nz-form-control nzErrorTip="Last name is required">
                        <input nz-input formControlName="lastName" placeholder="Customer last name" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzRequired>Phone Number</nz-form-label>
                    <nz-form-control nzErrorTip="Phone number is required">
                        <input nz-input formControlName="phoneNumber" placeholder="Phone number" />
                    </nz-form-control>
                </nz-form-item>

            </div>

            <div class="button-row">
                <button nz-button nzType="primary" nzBlock [nzLoading]="manualSyncLoading"
                    [disabled]="dishAccountForm.invalid">
                    Sync Account
                </button>
                <button nz-button nzType="default" nzBlock type="button" (click)="resetForm()"
                    [disabled]="manualSyncLoading">
                    Reset
                </button>
            </div>
        </form>
    </nz-card>

    <nz-card *ngIf="customerLookupMessage || customerDetails.length" class="result-card">
        <h2 nz-typography>Sync Result</h2>
        <p nz-typography *ngIf="customerLookupMessage">{{ customerLookupMessage }}</p>
        <dl *ngIf="customerDetails.length" class="result-summary">
            <ng-container *ngFor="let detail of customerDetails">
                <dt>{{ detail.label }}</dt>
                <dd>{{ detail.value }}</dd>
            </ng-container>
        </dl>
    </nz-card>
</div>
